module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hscmap":"hscMap","about_hscmap":"About hscMap","preferences":"Preferences...","tips":"Tips"},"ja":{"hscmap":"hscMap","about_hscmap":"hscMapについて","preferences":"環境設定...","tips":"Tips"}}')
  delete Component.options._Ctor
}
